import React from 'react';
import { TableRowPropsType } from '@insurancemenu/imenu-components-lib/dist/types';
import { TableRowStyled } from './styles';

const DashboardTableRow: React.FC<TableRowPropsType> = (props) => {
  return <TableRowStyled {...props} />;
};

export default DashboardTableRow;
